const game = {
  state: {
    periods: '',
    showBottom: false,
    gameName: '',
    selectNumber: [],
    selectNumberDigit: 0,
    gameInfo: {
      betting: ''
    },
    betResult: {

    }
  },

  mutations: {
    SET_PERIODS: (state, periods) => {
      state.periods = periods
    },
    SET_SHOW_BOTTOM: (state, isShow) => {
      state.showBottom = isShow;
    },
    SET_GAME_NAME: (state, name) => {
      state.gameName = name;
    },
    RESET_GAME_BOTTOM: (state) => {
      state.showBottom = false;
      state.gameName = '';
    },
    SET_GAME_SELECT_NUMBER: (state, {
      number,
      digit
    }) => {
      state.selectNumber = number;
      state.selectNumberDigit = digit;
    },
    RESET_GAME_SELECT_NUMBER: (state) => {
      state.selectNumber = [];
      state.selectNumberDigit = 0;
    },
    SET_GAME_INFO: (state, info) => {
      state.gameInfo = info;
    },
    SET_GAME_BET_RESULT: (state, info) => {
      state.betResult = info;
    }
  },

  actions: {
    setPeriods({
      commit
    }, periods) {
      commit('SET_PERIODS', periods);
    },
    setGameBottom({
      commit
    }, arg) {
      commit('SET_SHOW_BOTTOM', arg.isShow || false)
      commit('SET_GAME_NAME', arg.name)
    },
    resetGameBottom({
      commit
    }) {
      commit('RESET_GAME_BOTTOM')
    },
    setGameNumber({
      commit
    }, {
      number,
      digit
    }) {
      commit('SET_GAME_SELECT_NUMBER', {
        number,
        digit
      })
    },
    resetGameNumber({
      commit
    }) {
      commit('RESET_GAME_SELECT_NUMBER')
    },
    setGameInfo({
        commit
      },
      info
    ) {
      commit('SET_GAME_INFO', info)
    },
    setGameBetResult({
        commit
      },
      info
    ) {
      commit('SET_GAME_BET_RESULT', info)
    }
  }
}

export default game



// WEBPACK FOOTER //
// ./src/store/modules/game.js